import { useNavigate } from "react-router-dom";

import { RoutePath } from "../models/routePath";
import { TagName } from "../models/tag";

const useNavigateTo = () => {
  const navigate = useNavigate();

  const navigateBack = () => navigate(-1);
  const navigateToDashboard = () => navigate(RoutePath.Home);
  const navigateToNewOrder = () => navigate(RoutePath.NewOrder);
  const navigateToDeliveries = () => navigate(RoutePath.Deliveries);
  const navigateToDeliveriesWithTag = (tag: TagName) =>
    navigate(`${RoutePath.Deliveries}?tag=${tag}`);
  const navigateToDeliveryDetails = (id: string) =>
    navigate(`${RoutePath.Delivery}/${id}`);
  const navigateToEditOrder = (id: string) =>
    navigate(`${RoutePath.EditOrder}/${id}`);
  const navigateToSplitOrder = (id: string) =>
    navigate(`${RoutePath.SplitOrder}/${id}`);
  const navigateToConfirmQuantities = (id: string) =>
    navigate(`${RoutePath.ConfirmQuantities}/${id}`);
  const navigateToConfirmDate = (id: string) =>
    navigate(`${RoutePath.ConfirmDeliveryDate}/${id}`);
  const navigateToBookTimeSlot = (id: string) =>
    navigate(`${RoutePath.BookTimeSlot}/${id}`);

  return {
    navigateBack,
    navigateToDashboard,
    navigateToNewOrder,
    navigateToDeliveries,
    navigateToDeliveryDetails,
    navigateToEditOrder,
    navigateToSplitOrder,
    navigateToConfirmQuantities,
    navigateToConfirmDate,
    navigateToBookTimeSlot,
    navigateToDeliveriesWithTag,
  };
};

export default useNavigateTo;
